
import { ronBio, dumbledoreBio, harryBio } from './hermioneBios'
import { ronReviewerReviewHinge, dumbledoreReviewerReviewBumble, harryReviewerReviewTinder } from './hermioneReviewerReviews'

export const ronReviewerProfile = {
  _id: 'ronReviewerProfileId',
  userId: 'ronUserId',
  email: 'ron@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-5-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...ronBio },
  profileReviews: [
    // { ...ronProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...ronReviewerReviewHinge }
  ],
}

export const dumbledoreReviewerProfile = {
  _id: 'dumbledoreReviewerProfileId',
  userId: 'dumbledoreUserId',
  email: 'dumbledore@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-dumbledore-9-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: true,
  isHotty: false,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `Open AI gpt4o mini`,
  openAIAssistantID: `NA`,
  bio: { ...dumbledoreBio },
  profileReviews: [
    // { ...dumbledoreProfileReviewBumble }
  ],
  reviewerReviews: [
    { ...dumbledoreReviewerReviewBumble }
  ],
}

export const harryReviewerProfile = {
  _id: 'harryReviewerProfileId',
  userId: 'harryUserId',
  email: 'harry@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-5-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...harryBio },
  profileReviews: [
    // { ...harryProfileReviewTinder }
  ],
  reviewerReviews: [
    { ...harryReviewerReviewTinder }
  ],
}